import styled from "styled-components";
import { colors } from "../../../../../theme/theme";

export const TableWrapper = styled.div`
	.p-datatable .p-datatable-thead > tr > th {
		padding: 16px 4px 16px 16px;
		font-size: 13px;

		border: 0;
	}

	.p-datatable .p-datatable-tbody > tr > td {
		padding: 4px 8px 4px 16px;

		border: 0;
		border-bottom: 2px solid #fff;

		&:first-of-type {
			padding-left: 16px;
		}
	}

	.p-datatable .p-datatable-tbody > tr {
		box-shadow: none;
	}
`;

const Tag = styled.div`
	padding: 4px 8px;
	border-radius: 4px;
	width: fit-content;
`;

export const UsageTag = styled(Tag)`
	font-size: 12px;
	font-weight: 700;

	&.warn {
		color: ${colors.warning.orange_41};
		background: ${colors.warning.orange_11};
	}

	&.disabled {
		color: ${colors.greyscale.grey};
	}
`;

export const StatusTag = styled(Tag)`
	font-size: 10px;
	font-weight: 700;

	text-transform: uppercase;

	&.active {
		color: ${colors.primary.forest};
		background: ${colors.primary.light_green};
	}

	&.inactive {
		color: ${colors.danger.red_71};
		background: ${colors.danger.red_11};
	}

	&.canceled {
		color: ${colors.greyscale.darker_grey};
		background: ${colors.greyscale.light_grey};
	}
`;
